(function () {
  'use strict';

  var HANDLE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

  function priceToCents(value) {
    var normalized;
    if (typeof value === 'number') {
      if (!Number.isFinite(value) || value < 0) return null;
      normalized = String(value);
    } else if (typeof value === 'string') {
      normalized = value.trim();
    } else {
      return null;
    }
    if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
    var parts = normalized.split('.');
    var cents = Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
    return Number.isSafeInteger(cents) ? cents : null;
  }

  function getValidImages(product, limit) {
    if (!product || !Array.isArray(product.images)) return [];
    var maximum = Math.min(5, Math.max(0, Number.isInteger(limit) ? limit : 5));
    var seen = new Set();
    var valid = [];
    for (var index = 0; index < product.images.length && valid.length < maximum; index += 1) {
      var image = product.images[index];
      var source = typeof image === 'string' ? image : image && image.src;
      if (typeof source !== 'string') continue;
      try {
        var parsed = new URL(source);
        if (parsed.protocol !== 'https:' || seen.has(parsed.href)) continue;
        seen.add(parsed.href);
        valid.push({
          src: parsed.href,
          alt: typeof image.alt === 'string' && image.alt ? image.alt : (typeof product.title === 'string' ? product.title : '')
        });
      } catch (error) {
        continue;
      }
    }
    return valid;
  }

  function getLowestAvailablePrice(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var prices = product.variants
      .filter(function (variant) { return variant && variant.available === true; })
      .map(function (variant) { return priceToCents(variant.price); })
      .filter(function (price) { return price !== null; });
    return prices.length ? Math.min.apply(Math, prices) : null;
  }

  function hasGiftOnlyTag(product) {
    if (!product) return false;
    var tags = Array.isArray(product.tags) ? product.tags : (typeof product.tags === 'string' ? product.tags.split(',') : []);
    return tags.some(function (tag) { return typeof tag === 'string' && tag.trim().toLowerCase() === 'gift only'; });
  }

  function isEligible(product) {
    var type = String(product && product.product_type || '').trim().toLowerCase();
    var jewelry = /(?:^|\s)(?:necklaces?|pendants?|bracelets?|rings?|earrings?)$/.test(type) || type === 'mala beads' || type === 'prayer beads';
    if (!jewelry || /phone|bowl|cup|rug|textile|statue|ornament|chime/.test(type)) return false;
    var productTags = Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '');
    var evidence = (productTags + ' ' + product.title + ' ' + type).toLowerCase();
    if (/collector|collectible|收藏级|phone|bowl|cup|rug|carpet|textile|statue|ornament|chime|地毯|藏毯|杯|碗/.test(evidence)) return false;
    if (!Array.isArray(product.variants) || !product.variants.length || !product.variants.every(function (v) { var price = priceToCents(v.price); return price !== null && price <= 100000; })) return false;
    return Boolean(
      product &&
      typeof product.handle === 'string' && HANDLE.test(product.handle) &&
      typeof product.title === 'string' && product.title.trim() &&
      !hasGiftOnlyTag(product) &&
      product.variants && product.variants.some(function (v) { return v.available === true && v.requires_shipping === true; }) &&
      getLowestAvailablePrice(product) !== null &&
      getValidImages(product).length
    );
  }

  function dedupeProducts(products) {
    if (!Array.isArray(products)) return [];
    var seen = new Set();
    return products.filter(function (product) {
      if (!isEligible(product) || seen.has(product.handle)) return false;
      seen.add(product.handle);
      return true;
    });
  }

  async function loadProductPages(loadPage, pageSize, maxPages) {
    if (typeof loadPage !== 'function') throw new TypeError('loadPage must be a function');
    var size = Math.min(250, Math.max(1, Number.isInteger(pageSize) ? pageSize : 250));
    var pages = Math.min(4, Math.max(1, Number.isInteger(maxPages) ? maxPages : 4));
    var products = [];
    for (var page = 1; page <= pages; page += 1) {
      var payload = await loadPage(page, size);
      if (!payload || !Array.isArray(payload.products)) throw new Error('Malformed product page');
      products.push.apply(products, payload.products);
      if (payload.products.length < size) break;
    }
    return products;
  }

  function createDeck(products, random) {
    var deck = dedupeProducts(products).slice();
    var pick = typeof random === 'function' ? random : Math.random;
    for (var index = deck.length - 1; index > 0; index -= 1) {
      var sample = Number(pick());
      var swap = Math.floor((Number.isFinite(sample) ? Math.min(Math.max(sample, 0), 0.999999999999) : 0) * (index + 1));
      var temporary = deck[index];
      deck[index] = deck[swap];
      deck[swap] = temporary;
    }
    return deck;
  }

  function nextProduct(deck, currentHandle) {
    if (!Array.isArray(deck)) return null;
    var index = deck.findIndex(function (product) { return product && product.handle !== currentHandle; });
    return index < 0 ? null : deck.splice(index, 1)[0];
  }

  function createAutoplayController(tick, interval, clock) {
    if (typeof tick !== 'function') throw new TypeError('tick must be a function');
    var timers = clock || globalThis;
    if (!timers || typeof timers.setInterval !== 'function' || typeof timers.clearInterval !== 'function') {
      throw new TypeError('clock must provide setInterval and clearInterval');
    }
    var delay = Number.isFinite(interval) && interval >= 1000 ? Math.round(interval) : 3000;
    var timer = null;
    var started = false;
    var destroyed = false;
    var pauseReasons = new Set();

    function stopTimer() {
      if (timer === null) return;
      timers.clearInterval(timer);
      timer = null;
    }

    function schedule() {
      if (destroyed || !started || pauseReasons.size || timer !== null) return;
      timer = timers.setInterval(tick, delay);
    }

    return Object.freeze({
      start: function () {
        if (destroyed) return;
        started = true;
        schedule();
      },
      pause: function (reason) {
        if (destroyed) return;
        pauseReasons.add(reason || 'interaction');
        stopTimer();
      },
      resume: function (reason) {
        if (destroyed) return;
        pauseReasons.delete(reason || 'interaction');
        schedule();
      },
      restart: function () {
        if (destroyed) return;
        stopTimer();
        schedule();
      },
      destroy: function () {
        stopTimer();
        pauseReasons.clear();
        destroyed = true;
      }
    });
  }

  var api = Object.freeze({
    isEligible: isEligible,
    dedupeProducts: dedupeProducts,
    getValidImages: getValidImages,
    getLowestAvailablePrice: getLowestAvailablePrice,
    loadProductPages: loadProductPages,
    createDeck: createDeck,
    nextProduct: nextProduct,
    createAutoplayController: createAutoplayController
  });
  globalThis.PKHomeObjectDiscovery = api;

  if (typeof document === 'undefined' || typeof matchMedia !== 'function') return;

  var controllers = new WeakMap();

  function delimit(cents, decimals, thousands, decimal) {
    var amount = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents, format, varies) {
    if (globalThis.Shopify && typeof globalThis.Shopify.formatMoney === 'function') {
      try {
        var shopifyValue = globalThis.Shopify.formatMoney(cents, format);
        if (typeof shopifyValue === 'string' && shopifyValue && !/{{[\s\S]*?}}/.test(shopifyValue)) {
          return (varies ? 'From ' : '') + shopifyValue;
        }
      } catch (error) {
        // Fall through to the safe text formatter.
      }
    }
    var template = typeof format === 'string' && format ? format : '${{ amount }}';
    var value = template
      .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/g, delimit(cents, false, '.', ','))
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, delimit(cents, true, '.', ','))
      .replace(/{{\s*amount_no_decimals\s*}}/g, delimit(cents, false, ',', '.'))
      .replace(/{{\s*amount\s*}}/g, delimit(cents, true, ',', '.'));
    if (/{{[\s\S]*?}}/.test(value)) value = '$' + delimit(cents, true, ',', '.');
    return (varies ? 'From ' : '') + value;
  }

  function normalizeProduct(product) {
    if (!isEligible(product)) return null;
    var availablePrices = product.variants
      .filter(function (variant) { return variant && variant.available === true; })
      .map(function (variant) { return priceToCents(variant.price); })
      .filter(function (price) { return price !== null; });
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: '/products/' + product.handle,
      images: getValidImages(product, 5),
      priceCents: Math.min.apply(Math, availablePrices),
      priceVaries: Boolean(product.price_varies || new Set(availablePrices).size > 1)
    };
  }

  function rootsWithin(target) {
    var roots = [];
    if (target && target.nodeType === 1 && target.hasAttribute('data-pk-home-object-discovery')) roots.push(target);
    if (target && typeof target.querySelectorAll === 'function') {
      roots.push.apply(roots, target.querySelectorAll('[data-pk-home-object-discovery]'));
    }
    return roots;
  }

  function setBusy(shuffle, busy) {
    shuffle.disabled = busy;
    if (busy) shuffle.setAttribute('aria-busy', 'true');
    else shuffle.removeAttribute('aria-busy');
  }

  function createThumbnail(documentRef, image, title, selected) {
    var button = documentRef.createElement('button');
    button.className = 'pk-home-object-discovery__thumbnail thumbnail';
    button.setAttribute('type', 'button');
    button.setAttribute('data-pk-home-object-thumbnail', '');
    button.setAttribute('aria-label', 'View alternate image of ' + title);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    var thumbnail = documentRef.createElement('img');
    thumbnail.setAttribute('src', image.src);
    thumbnail.setAttribute('alt', image.alt);
    thumbnail.setAttribute('loading', 'lazy');
    button.appendChild(thumbnail);
    return button;
  }

  function stageProduct(root, product, moneyFormat) {
    if (!product || !HANDLE.test(product.handle) || product.url !== '/products/' + product.handle || !product.images.length) throw new Error('Malformed normalized product');
    var fragment = document.createDocumentFragment();
    for (var index = 1; index < product.images.length; index += 1) {
      fragment.appendChild(createThumbnail(document, product.images[index], product.title, false));
    }
    var hooks = {
      mainLink: root.querySelector('[data-pk-home-object-main-link]'),
      mainImage: root.querySelector('[data-pk-home-object-main-image]'),
      thumbnails: root.querySelector('[data-pk-home-object-thumbnails]'),
      title: root.querySelector('[data-pk-home-object-title]'),
      price: root.querySelector('[data-pk-home-object-price]'),
      collectorSeal: root.querySelector('[data-pk-home-object-collector-seal]'),
      cta: root.querySelector('[data-pk-home-object-cta]'),
      shuffle: root.querySelector('[data-pk-home-object-shuffle]'),
      status: root.querySelector('[data-pk-home-object-status]')
    };
    if (Object.keys(hooks).some(function (key) { return !hooks[key]; })) throw new Error('Missing discovery hook');
    return {
      fragment: fragment,
      hooks: hooks,
      product: product,
      moneyFormat: moneyFormat,
      price: formatMoney(product.priceCents, moneyFormat, product.priceVaries),
      collectorSeal: product.priceCents > 100000
    };
  }

  function readAttribute(node, name) {
    return node.hasAttribute(name) ? node.getAttribute(name) : null;
  }

  function restoreAttribute(node, name, value) {
    if (value === null) node.removeAttribute(name);
    else node.setAttribute(name, value);
  }

  function snapshotProduct(root, hooks) {
    return {
      handle: readAttribute(root, 'data-current-handle'),
      mainHref: readAttribute(hooks.mainLink, 'href'),
      mainAria: readAttribute(hooks.mainLink, 'aria-label'),
      imageSrc: readAttribute(hooks.mainImage, 'src'),
      imageSrcset: readAttribute(hooks.mainImage, 'srcset'),
      imageAlt: readAttribute(hooks.mainImage, 'alt'),
      thumbnails: Array.from(hooks.thumbnails.children),
      title: hooks.title.textContent,
      price: hooks.price.textContent,
      collectorSealHidden: hooks.collectorSeal.hidden,
      ctaHref: readAttribute(hooks.cta, 'href'),
      status: hooks.status.textContent
    };
  }

  function restoreProduct(root, hooks, snapshot) {
    restoreAttribute(hooks.mainLink, 'href', snapshot.mainHref);
    restoreAttribute(hooks.mainLink, 'aria-label', snapshot.mainAria);
    restoreAttribute(hooks.mainImage, 'src', snapshot.imageSrc);
    restoreAttribute(hooks.mainImage, 'srcset', snapshot.imageSrcset);
    restoreAttribute(hooks.mainImage, 'alt', snapshot.imageAlt);
    hooks.thumbnails.replaceChildren.apply(hooks.thumbnails, snapshot.thumbnails);
    hooks.title.textContent = snapshot.title;
    hooks.price.textContent = snapshot.price;
    hooks.collectorSeal.hidden = snapshot.collectorSealHidden;
    restoreAttribute(hooks.cta, 'href', snapshot.ctaHref);
    restoreAttribute(root, 'data-current-handle', snapshot.handle);
    hooks.status.textContent = snapshot.status;
  }

  function commitProduct(root, staged, announce) {
    var product = staged.product;
    var hooks = staged.hooks;
    var snapshot = snapshotProduct(root, hooks);
    try {
      hooks.mainLink.setAttribute('href', product.url);
      hooks.mainLink.setAttribute('aria-label', 'View ' + product.title);
      hooks.mainImage.setAttribute('src', product.images[0].src);
      hooks.mainImage.setAttribute('srcset', product.images[0].src + ' 1x');
      hooks.mainImage.setAttribute('alt', product.images[0].alt);
      hooks.thumbnails.replaceChildren(staged.fragment);
      hooks.title.textContent = product.title;
      if (globalThis.PKOpeningSale) globalThis.PKOpeningSale.renderPrice(hooks.price, product, product.priceCents, function (amount) { return formatMoney(amount, staged.moneyFormat, product.priceVaries); });
      else hooks.price.textContent = staged.price;
      hooks.collectorSeal.hidden = !staged.collectorSeal;
      hooks.cta.setAttribute('href', product.url);
      root.setAttribute('data-current-handle', product.handle);
      hooks.status.textContent = announce ? product.title + ' is now displayed.' : '';
    } catch (error) {
      restoreProduct(root, hooks, snapshot);
      throw error;
    }
  }

  function createTieredDeck(products) {
    var multiple = [];
    var single = [];
    dedupeProducts(products).forEach(function (product) {
      (getValidImages(product, 2).length >= 2 ? multiple : single).push(product);
    });
    return createDeck(multiple).concat(createDeck(single));
  }

  function initialize(root) {
    if (!root || controllers.has(root)) return;
    var configNode = root.querySelector('[data-pk-home-object-config]');
    var shuffle = root.querySelector('[data-pk-home-object-shuffle]');
    if (!configNode || !shuffle) return;
    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    const endpoint = new URL('/collections/all/products.json', location.origin);
    var configured;
    try {
      configured = new URL(config.allProductsUrl, location.origin);
    } catch (error) {
      return;
    }
    if (configured.origin !== endpoint.origin || configured.pathname !== endpoint.pathname) return;

    var interval = Number(config.interval);
    if (!Number.isFinite(interval) || interval < 1000) interval = 3000;
    var reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    var state = { busy: false, deck: [], pool: [], rawPool: [], token: 0, moneyFormat: config.moneyFormat, reducedMotion: reducedMotion };
    controllers.set(root, state);

    async function loadPage(page, pageSize) {
      endpoint.search = '';
      endpoint.searchParams.set('page', String(page));
      endpoint.searchParams.set('limit', String(pageSize));
      var result = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!result || result.ok !== true || typeof result.json !== 'function') throw new Error('Product request failed');
      return result.json();
    }

    var generation = state.token;
    state.poolPromise = loadProductPages(loadPage, 250, 4).then(function (products) {
      if (controllers.get(root) !== state || state.token !== generation || !root.isConnected) return [];
      state.rawPool = dedupeProducts(products);
      var normalized = state.rawPool.map(normalizeProduct).filter(Boolean);
      normalized.sort(function (left, right) { return Number(right.images.length >= 2) - Number(left.images.length >= 2); });
      state.pool = normalized;
      state.deck = createTieredDeck(state.rawPool).filter(function (product) {
        return product.handle !== root.getAttribute('data-current-handle');
      });
      var hasAlternatives = normalized.filter(function (product) { return product.handle !== root.getAttribute('data-current-handle'); }).length > 0;
      shuffle.hidden = !hasAlternatives;
      if (hasAlternatives) shuffleProduct(false);
      if (hasAlternatives && !reducedMotion.matches) state.autoplay.start();
      return normalized;
    });
    state.poolPromise.catch(function () { return []; });

    async function shuffleProduct(announce) {
      if (state.busy) return;
      state.busy = true;
      setBusy(shuffle, true);
      var token = state.token;
      try {
        await state.poolPromise;
        if (token !== state.token || !root.isConnected) return;
        var workingDeck = state.deck.slice();
        var current = root.getAttribute('data-current-handle');
        var raw = nextProduct(workingDeck, current);
        if (!raw && state.pool.length > 1) {
          workingDeck = createTieredDeck(state.rawPool);
          raw = nextProduct(workingDeck, current);
        }
        var product = raw && normalizeProduct(raw);
        if (!product) return;
        var staged = stageProduct(root, product, state.moneyFormat);
        if (token !== state.token || !root.isConnected) return;
        commitProduct(root, staged, announce === true);
        state.deck = workingDeck;
      } catch (error) {
        return;
      } finally {
        state.busy = false;
        if (controllers.get(root) === state) setBusy(shuffle, false);
      }
    }

    function onClick(event) {
      var thumbnail = event.target && event.target.closest ? event.target.closest('[data-pk-home-object-thumbnail]') : null;
      if (thumbnail && root.contains(thumbnail)) {
        var image = thumbnail.querySelector('img');
        var main = root.querySelector('[data-pk-home-object-main-image]');
        if (!image || !main) return;
        var source = image.getAttribute('src');
        if (typeof source !== 'string' || !/^(?:https:)?\/\//i.test(source.trim())) return;
        source = source.trim();
        var parsedSource;
        try {
          parsedSource = new URL(source, location.origin);
          if (parsedSource.protocol !== 'https:') return;
        } catch (error) {
          return;
        }
        root.querySelectorAll('[data-pk-home-object-thumbnail]').forEach(function (button) { button.setAttribute('aria-pressed', button === thumbnail ? 'true' : 'false'); });
        main.setAttribute('src', parsedSource.href);
        main.setAttribute('srcset', image.getAttribute('srcset') || parsedSource.href + ' 1x');
        main.setAttribute('alt', image.getAttribute('alt') || '');
        return;
      }
      var control = event.target && event.target.closest ? event.target.closest('[data-pk-home-object-shuffle]') : null;
      if (control && root.contains(control)) {
        shuffleProduct(true);
        state.autoplay.restart();
      }
    }

    state.autoplay = createAutoplayController(function () { shuffleProduct(false); }, interval);
    state.onPointerEnter = function () { state.autoplay.pause('pointer'); };
    state.onPointerLeave = function () { state.autoplay.resume('pointer'); };
    state.onFocusIn = function () { state.autoplay.pause('focus'); };
    state.onFocusOut = function (event) {
      if (!event.relatedTarget || !root.contains(event.relatedTarget)) state.autoplay.resume('focus');
    };
    state.onTouchStart = function () { state.autoplay.pause('touch'); };
    state.onTouchEnd = function () { state.autoplay.resume('touch'); };
    state.onVisibilityChange = function () {
      if (document.hidden) state.autoplay.pause('visibility');
      else state.autoplay.resume('visibility');
    };
    state.onReducedMotionChange = function (event) {
      if (event.matches) state.autoplay.pause('reduced-motion');
      else state.autoplay.resume('reduced-motion');
    };
    if (reducedMotion.matches) state.autoplay.pause('reduced-motion');
    if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', state.onReducedMotionChange);
    if (typeof IntersectionObserver === 'function') {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          if (entry.isIntersecting) state.autoplay.resume('viewport');
          else state.autoplay.pause('viewport');
        });
      }, { threshold: 0.15 });
      state.autoplay.pause('viewport');
      state.observer.observe(root);
    }

    state.onClick = onClick;
    root.addEventListener('click', onClick);
    root.addEventListener('mouseenter', state.onPointerEnter);
    root.addEventListener('mouseleave', state.onPointerLeave);
    root.addEventListener('focusin', state.onFocusIn);
    root.addEventListener('focusout', state.onFocusOut);
    root.addEventListener('touchstart', state.onTouchStart, { passive: true });
    root.addEventListener('touchend', state.onTouchEnd, { passive: true });
    root.addEventListener('touchcancel', state.onTouchEnd, { passive: true });
    document.addEventListener('visibilitychange', state.onVisibilityChange);
  }

  function teardown(root) {
    var waiting = pending.get(root);
    if (waiting) { waiting.disconnect(); pending.delete(root); }
    var state = controllers.get(root);
    if (!state) return;
    state.token += 1;
    state.autoplay.destroy();
    if (state.observer) state.observer.disconnect();
    if (typeof state.reducedMotion.removeEventListener === 'function') state.reducedMotion.removeEventListener('change', state.onReducedMotionChange);
    root.removeEventListener('click', state.onClick);
    root.removeEventListener('mouseenter', state.onPointerEnter);
    root.removeEventListener('mouseleave', state.onPointerLeave);
    root.removeEventListener('focusin', state.onFocusIn);
    root.removeEventListener('focusout', state.onFocusOut);
    root.removeEventListener('touchstart', state.onTouchStart);
    root.removeEventListener('touchend', state.onTouchEnd);
    root.removeEventListener('touchcancel', state.onTouchEnd);
    document.removeEventListener('visibilitychange', state.onVisibilityChange);
    controllers.delete(root);
  }

  var pending = new WeakMap();
  function prepare(root) {
    if (!root || controllers.has(root) || pending.has(root)) return;
    if (typeof IntersectionObserver === 'undefined') { initialize(root); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (pending.get(root) !== observer || !root.isConnected) return;
      if (!entries.some(function (entry) { return entry.target === root && entry.isIntersecting; })) return;
      observer.disconnect();
      pending.delete(root);
      initialize(root);
    }, { rootMargin: '800px 0px' });
    pending.set(root, observer);
    observer.observe(root);
  }
  function initializeWithin(target) { rootsWithin(target).forEach(prepare); }
  function teardownWithin(target) { rootsWithin(target).forEach(teardown); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { teardownWithin(event.target); });
}());
